import React from 'react';
import Icon from '../../../components/AppIcon';

const UsageTrackingCard = ({ usageData = [], plan }) => {
  const getUsageItems = () => {
    if (usageData?.length > 0) {
      return usageData?.map(item => ({
        label: item?.resource_type?.replace(/_/g, ' ')?.replace(/\b\w/g, c => c?.toUpperCase()),
        used: item?.usage_count || 0,
        limit: item?.usage_limit || 0,
        icon: item?.resource_type === 'leads' ? 'Users' : item?.resource_type === 'campaigns' ? 'Send' : 'Activity'
      }));
    }
    return [
      { label: 'Leads', used: 0, limit: plan?.features?.leads || 100, icon: 'Users' },
      { label: 'Campaigns', used: 0, limit: plan?.features?.campaigns || 5, icon: 'Send' },
      { label: 'Emails', used: 0, limit: plan?.features?.emails || 500, icon: 'Mail' }
    ];
  };

  const items = getUsageItems();

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <div className="flex items-center space-x-3 mb-6">
        <div className="p-2 bg-primary/10 rounded-lg">
          <Icon name="BarChart3" size={20} className="text-primary" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">Usage Tracking</h3>
      </div>
      <div className="space-y-4">
        {items?.map((item, index) => {
          const pct = item?.limit > 0 ? Math.min(Math.round((item?.used / item?.limit) * 100), 100) : 0;
          const isUnlimited = item?.limit === -1;
          return (
            <div key={index}>
              <div className="flex items-center justify-between mb-1">
                <div className="flex items-center space-x-2">
                  <Icon name={item?.icon} size={14} className="text-muted-foreground" />
                  <span className="text-sm font-medium text-foreground">{item?.label}</span>
                </div>
                <span className="text-sm text-muted-foreground">
                  {isUnlimited ? `${item?.used} / Unlimited` : `${item?.used} / ${item?.limit}`}
                </span>
              </div>
              {!isUnlimited && (
                <div className="w-full bg-muted rounded-full h-2">
                  <div
                    className={`h-full rounded-full transition-all ${
                      pct < 50 ? 'bg-success' : pct < 80 ? 'bg-warning' : 'bg-destructive'
                    }`}
                    style={{ width: `${pct}%` }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UsageTrackingCard;